module.exports = __webpack_public_path__ + "c5a4ba549ad12ec98acca57b38c89e08.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/graphic_blue.png
// module id = 227
// module chunks = 0